import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

export default function Pagination({currentPage, setCurrentPage, pages, }) {
  return (
    <div className='flex gap-2'>
      {
            currentPage > 0 &&
            <>
              <button
                onClick={() => setCurrentPage(0)}
              >
                <FaChevronLeft />
              </button>
              <button
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                <FaChevronLeft />
              </button>
            </>
          }
          {
            Array.from(Array(pages), (item, index) => {
              return (
                <button
                  key={index}
                  value={index}
                  onClick={(e) => setCurrentPage(Number(e.target.value))}
                  className='bg-white px-2 rounded shadow font-medium text-gray-500 hover:bg-gray-200'
                >
                  {index + 1}
                </button>
              )
            })
          }
          {
            currentPage < pages -1 &&
            <>
              <button
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                <FaChevronRight  />
              </button>
              <button
                onClick={() => setCurrentPage(pages - 1)}
              >
                <FaChevronRight />
              </button>
            </>
          }
    </div>
  )
};